import { ENVIRONMENT_STAMP } from '../../utils/env';
import ToggleThemeButton from '../buttons/ToggleThemeButton/ThemeToggleButton';
import UserProfileButton from '../buttons/UserProfileButton';
import ApplicationName from './ApplicationName';
import styles from './Header.module.scss';

import MarketSelectorButton from '../buttons/MarketSelectorButton';
import { SkipToMain } from './SkipToMain';
import HeaderAppsButton from './HeaderAppsButton';

const style = ENVIRONMENT_STAMP
  ? { backgroundColor: 'rgb(var(--color-environment-stamp))' }
  : undefined;

const Header = () => {
  return (
    <div className={styles.headerComponent} style={style}>
      <SkipToMain />
      <ApplicationName />
      <div className={styles.group}>
        <HeaderAppsButton />
        <MarketSelectorButton />
        <UserProfileButton />
        <ToggleThemeButton />
      </div>
    </div>
  );
};

export default Header;
